export enum RewardType {
  Premium = 'PREMIUM',
  NonPremium = 'NON_PREMIUM',
}

export enum RedemptionChannel {
  All = 'All',
  Delivery = 'Delivery',
  InStore = 'InStore',
  Kiosk = 'Kiosk',
  Outpost = 'Outpost',
  Pickup = 'Pickup',
}

export type BagReward = Readonly<{
  id: string;
  name: string;
  assetUrl?: string | null;
  terms?: string | null;
  points?: number | null;
  expirationDate?: string | null;
  rewardType?: RewardType | null;
  redemptionChannel?: RedemptionChannel | null;
  redeemable?: boolean | null;
  redeemableAt?: string | null;
}>;
